{
  "name": "@akiru/landing-app",
  "version": "0.3.7",
  "repository": {
    "url": "git@gitlab.com:akiru/company/services/landing-app.git"
  },
  "author": "Daniel Bergdahl <rexsuecia@gmail.com>",
  "scripts": {
    "install": "cp package.json ./public",
    "ng": "ng",
    "start": "ng serve --port 4800 --ssl --host localhost.akiru.se",
    "build": "./scripts/version.sh && ng build --output-hashing all",
    "test": "ng test",
    "lint": "ng lint",
    "style-lint": "stylelint  src/**/*.scss --fix"
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "21.0.5",
    "@angular/common": "^21.0.0",
    "@angular/compiler": "^21.0.0",
    "@angular/core": "^21.0.0",
    "@angular/forms": "^21.0.0",
    "@angular/material": "21.0.5",
    "@angular/platform-browser": "^21.0.0",
    "@angular/router": "^21.0.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "21.1.0",
    "@angular/build": "^21.0.4",
    "@angular/cli": "^21.0.4",
    "@angular/compiler-cli": "^21.0.0",
    "@eslint/js": "^9.39.1",
    "@stylistic/eslint-plugin": "^5.6.1",
    "@types/jsdom": "^27",
    "@vitest/browser-playwright": "^4.0.16",
    "@vitest/coverage-v8": "^4.1.5",
    "angular-eslint": "21.1.0",
    "eslint": "^9.39.1",
    "jsdom": "^27.4.0",
    "postcss": "^8.5.6",
    "stylelint": "^17.11.0",
    "stylelint-config-sass-guidelines": "^13.0.0",
    "stylelint-config-standard-scss": "^17.0.0",
    "typescript": "~5.9.2",
    "typescript-eslint": "8.47.0",
    "vitest": "^4.1.5"
  }
}
